import { HStack } from "@/components/ui/hstack";
import { Link, LinkText } from "@/components/ui/link";
import { Text } from "@/components/ui/text";
import { useNavigationTitleHistory } from "@/utils/useNavigationTitleHistory";
import { cn } from "@gluestack-ui/nativewind-utils/cn";
import { useLinkBuilder, useNavigationState } from "@react-navigation/native";
import { Link as ExpoLink } from "expo-router";

export function WebBreadcrumbs() {
  const routes = useNavigationState((s) => s.routes);
  const history = useNavigationTitleHistory();
  const { buildHref } = useLinkBuilder();

  return (
    <HStack className="w-full gap-x-4 gap-y-0 rounded-md bg-background-100 px-4 py-1 flex-wrap mt-4">
      {routes.map((r, index) => {
        const isLast = index == routes.length - 1;
        return (
          <HStack key={r.key} className="gap-4 items-center">
            <ExpoLink
              href={{ pathname: buildHref(r.name, r.params) as any }}
              dismissTo
              disabled={isLast}
            >
              <LinkText
                size="sm"
                className={cn([
                  { "text-typography-black": isLast, "no-underline": isLast },
                ])}
              >
                {history.options[r.key]?.title || r.name}
              </LinkText>
            </ExpoLink>
            {!isLast && <Text className="text-sm">/</Text>}
          </HStack>
        );
      })}
    </HStack>
  );
}
